import { formatNumberWithComma, Panel, TaskDetail } from '@pulseops/common'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { InfoViewList, Title } from '../common'

interface Props {
  detail: TaskDetail.ChangeSumAssured
}

export const ChangeSumAssured = ({ detail }: Props) => {
  const { t } = useTranslation()

  return (
    <View style={{ flex: 1 }}>
      <Title title={t('submission:ChangeSumAssured')} />
      <Panel key={0} isExand={false} containerStyle={{ backgroundColor: '#FAFAFA' }}>
        <InfoViewList
          dataSource={[
            {
              label: t('submission:CurrentSumAssured'),
              value: formatNumberWithComma(detail.currentSumAssured),
              suffix: 'VND'
            },
            // {
            //   label: t('submission:MinSumAssured'),
            //   value: formatNumberWithComma(detail.minimumSumAssured),
            //   suffix: 'VND'
            // },
            // {
            //   label: t('submission:MaxSumAssured'),
            //   value: formatNumberWithComma(detail.maximumSumAssured),
            //   suffix: 'VND'
            // },

            {
              label: t('submission:NewSumAssured'),
              value: formatNumberWithComma(detail.newSumAssured),
              suffix: 'VND'
            },
            {
              label: t('submission:CurrentInstallPremium'),
              value: formatNumberWithComma(detail.currentInstallmentPremium),
              suffix: 'VND'
            },
            {
              label: t('submission:NewInstallPremium'),
              value: formatNumberWithComma(detail.newInstallmentPremium),
              suffix: 'VND'
            },
            {
              label: t('submission:RequirePayInAmount'),
              value: formatNumberWithComma(detail.requirePayInAmount),
              suffix: 'VND',
              isHighlight: true,
              isBold: true
            }
          ]}
        />
      </Panel>
    </View>
  )
}
